<template>
  <div id="account" class="">
    <form>
      <div class="account-type align-hor padding-20 space-even">
        <div v-for="type in acTypes">
          <input type="radio" v-model="acType" :value="type" :id="type">
          <label :for="type">{{ type | uppercase }}</label>
        </div>
      </div>

      <div class="account-details margin-10 padding-10 radius-10 bg-light">
        <div class="align-ver" v-if="this.acType == 'paytm'">
          <input type="number" ref="accNo" name="accNum" v-model="account.number" placeholder="Mobile Number" class="text-regular margin-bottom-15">
        </div>
        <div class="align-ver" v-else-if="this.acType == 'bank'">
          <input type="text" ref="user_name" name="user_name" v-model="account.user_name" placeholder="Account Holder's Name" class="text-regular margin-bottom-15">
          <input type="text" ref="bank_name" name="bank_name" v-model="account.bank_name" placeholder="Bank's Name" class="text-regular margin-bottom-15">
          <input type="text" ref="ifsc" name="ifsc" v-model="account.ifsc" placeholder="IFSC" class="text-regular margin-bottom-15">
          <input type="number" ref="accNo" name="accNum" v-model="account.number" placeholder="Account Number" class="text-regular margin-bottom-15">
        </div>
        <div class="align-ver" v-else>
          <input type="text" ref="upi" name="upi" v-model="account.upi_id" placeholder="UPI ID" class="text-regular margin-bottom-15">
        </div>
      </div>

      <div class="pos-abs pull-down-20 align-ver center-ver padding-20 pos-center-hor">
        <div class="wrapper" v-if="is_loading">
          <div class="comment animate margin-bottom-5"></div>
          <div class="comment animate margin-bottom-5"></div>
          <div class="align-ver center-ver">
            <div class="install-invite-button comment animate radius-5"></div>
          </div>
        </div>
        <div v-else>
          <div v-if="has_ac_details && !isRedeemable">
            <a class="install-invite text-center radius-5" v-if="isProcessing">Saving...</a>
            <a class="install-invite text-center radius-5" @click="saveAccountInfo('update')" v-else>Save</a>
          </div>
          <div class="align-ver center-ver" v-else>
            <p class="text-center">₹{{cash_earned}} will be transferred to the above mentioned account</p>
            <p class="text-center">
              <a class="install-invite text-center radius-5" v-if="isProcessing">Transferring...</a>
              <a class="install-invite text-center radius-5" @click="saveAccountInfo('redeem')" v-else>Transfer</a>
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  export default {
    mixins: [globals],
    data() {
      return {
        acType: 'bank',
        acTypes: [
          "bank",
          // "paytm",
          // "upi"
        ],
        accounts: [],
        empty_acc: {
          id: '',
          number: '',
          user_name: '',
          bank_name: '',
          ifsc: '',
          upi_id: '',
        },
        tr_id: '',
        cash_earned: '',
        has_ac_details: "",
        is_loading: true,
      }
    },
    computed: {
      account: function() {
        var self = this;
        var data;
        if(self.accounts.length > 0){
          var selectedAccount = self.accounts.filter(function(ac) {
            return ac.ac_type === self.acType;
          });
          data = (selectedAccount.length > 0) ? selectedAccount[0] : [];
        } else {
          data = self.empty_acc;
        }

        return data;
      }
    },
    methods: {
      fetchAccountDetails() {
        var self = this;
        var url = this.$store.getters.gamesDomain+'/web_wallet';

        url += '?partner='+self.partnerID+'&contact_number='+self.userPhone;

        var headers = this.$store.getters.headers;

        axios.get(url, {
          headers: headers
        }).then((resp) => {
          if(resp.status == 200) {
            var data = resp.data;
            var tempArr = [];
            var user_accounts = data.user_accounts;
            self.cash_earned = data.total_cash_earned;
            self.$store.state.redeem = data.is_redeemable;
            self.$store.state.requestedTR = (data.hasOwnProperty("transfer_request") && !self.isEmpty(data.transfer_request));
            if(self.isTRPending) {
              self.tr_id = data.transfer_request.id;
            }

            if(user_accounts.length) {
              self.has_ac_details = true;
              user_accounts.forEach(function(ua) {
                var tempObj = {};
                var ac_type = ua.ac_type;
                tempObj.ac_type = ac_type;
                if(ac_type == 'paytm') {
                  tempObj.id = ua.id
                  tempObj.number = ua.number;
                } else if(ua.ac_type == 'upi') {
                  tempObj.id = ua.id
                  tempObj.upi_id = ua.upi_id;
                } else if(ua.ac_type == 'bank') {
                  tempObj.id = ua.id
                  tempObj.upi_id = ua.upi_id;
                  tempObj.number = ua.number;
                  tempObj.user_name = ua.user_name;
                  tempObj.bank_name = ua.bank_name;
                  tempObj.ifsc = ua.ifsc;
                }
                tempArr.push(tempObj);
              })

              self.accounts = tempArr;
            }
            self.is_loading = false;
          } else {
            console.log("Error fetching the wallet data");
          }
        })
      },
      saveAccountInfo(type) {
        var self = this;
        var url;
        var method;
        if(type == "redeem") {
          url = this.$store.getters.gamesDomain+'/transfer_request_webs';
          method = 'post'
        } else {
          var acc_id = self.account.id ? self.account.id : 0;
          url = this.$store.getters.gamesDomain+'/transfer_request_webs/'+acc_id;
          method = 'put'
        }

        url += '?partner='+self.partnerID+'&contact_number='+self.userPhone;

        var headers = this.$store.getters.headers;

        var account_number = self.account.number;
        var user_name = self.account.user_name;
        var bank_name = self.account.bank_name;
        var ifsc = self.account.ifsc;
        var upi_id = self.account.upi_id;
        var tr_id = self.tr_id;

        var input_value = account_number;
        var is_valid_account = false;
        var account;
        if(self.acType == 'paytm') {
          var validate_account = self.validateInput("phone", input_value, "mobile number");

          is_valid_account = (validate_account && input_value.length == 10);

          if(!is_valid_account) {
            return;
          } else {
            account = {
              ac_type: self.acType,
              number: account_number,
              tr_id: tr_id,
            }
          }
        } else if(self.acType == 'bank') {
          var validate_account = self.validateInput("account", input_value, "account number");

          is_valid_account = (validate_account && input_value.length >= 9);

          if (!user_name) {
            console.log("Please provide the Account holder's name");
            return;
          } else if (!bank_name) {
            console.log("Please provide the Bank name");
            return;
          }  else if (!ifsc) {
            console.log("Please provide IFSC");
            return;
          } else if(!is_valid_account) {
            return;
          } else {
            account = {
              ac_type: self.acType,
              number: account_number,
              user_name: user_name,
              bank_name: bank_name,
              ifsc: ifsc,
              tr_id: tr_id,
            }
          }
        } else {
          if(upi_id) {
            is_valid_account = true;
            account = {
              ac_type: self.acType,
              upi_id: upi_id,
              tr_id: tr_id
            }
          }
        }

        if(is_valid_account) {

          var data = {};
          if(method == 'post') {
            data = account;
          } else {
            data = account;
          }

          self.$store.state.processing = true;
          var options = {
            method: method,
            url: url,
            headers: headers,
            data: data,
          }

          // console.log("~~~~~~~~~~"+JSON.stringify(options));

          axios(options).then((resp) => {
            if(resp.status == 200 || resp.status == 201) {

              var success = resp.data.success;
              var message = resp.data.message;
              if (success) {
                self.$store.state.requestedTR = (data.hasOwnProperty("transfer_request") && !self.isEmpty(data.transfer_request));

                var type = "success"
                if(self.$store.state.requestedTR) {
                  message = "Your redeem request has been received successfully!"
                } else {
                  message = "Your " + self.acType.toUpperCase() + " datails are updated successfully!"
                }

                if(self.isRedeemable) {
                  this.$store.state.redeem = false;
                }
                self.back();
              } else {
                self.$store.state.processing = false;
                self.alertPopup(true, message);
              }
            } else {
              var type = "error"
              var message = "Your " + self.acType.toUpperCase() + " datails coundn\'t be updated!"
              self.$store.state.processing = false;
              self.alertPopup(true, message);
            }
          }).catch((err) => {
            console.log("Redemption error!"+err);
            self.$store.state.processing = false;
          });
        } else {
          console.log("Invalid Account!");
        }
      }
    },
    created() {
      /*if(!this.isUserLoggedIn) {
        this.redirectTo('', '');
      } else {*/
      this.$store.state.headTitle = "Redeem";
      this.$store.state.showHeader = true;
      this.$store.state.showHistory = false;
      this.$store.state.showWallet = false;
        this.fetchAccountDetails();
      // }
    }
  }
</script>
<style>
  #account input,
  #account  input:focus,
  #account  input:active {
    outline: none;
    border: none;
    padding: 20px 5px 5px;
    border-bottom: 1px solid #CCCCCC;
  }
  #account input:focus{
    outline: none;
    border: none;
  }
  .account-details {
    border: 1px solid #CCCCCC;
  }

  #account [type="radio"]:checked,
  #account [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
    border: none;
    outline: none;
  }

  #account [type="radio"]:checked + label,
  #account [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    line-height: 22px;
    display: inline-block;
    color: #666;
  }
  #account [type="radio"]:checked + label:before,
  #account [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2px solid #333333;
    border-radius: 100%;
    background: #fff;
  }
  #account [type="radio"]:checked + label:after,
  #account [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 12px;
    height: 12px;
    background: #333333;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  #account [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  #account [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  .install-invite-button {
    width: 90px;
    height: 38px;
  }
</style>